import 'css-chunksrc/client/pages/zonesPage/reportsPage/toolbar/sort/styles.scss';export default {
  "root": "_root_1r4yd_1",
  "listRoot": "_listRoot_1r4yd_5",
  "input": "_input_1r4yd_13",
  "opened": "_opened_1r4yd_30",
  "icon": "_icon_1r4yd_35",
  "list": "_list_1r4yd_5",
  "item": "_item_1r4yd_55",
  "selected": "_selected_1r4yd_65"
};